/**
 * 툴바 및 드롭다운 관련 스타일 컴포넌트
 */
import styled from 'styled-components';

export const SelectionToolbar = styled.div<{ $x: number; $y: number }>`
  position: fixed;
  left: ${props => props.$x}px;
  top: ${props => props.$y}px;
  width: max-content;
  background-color: transparent;
  border: none;
  border-radius: ${props => props.theme.borderRadius.md};
  box-shadow: none;
  padding: 0;
  display: flex;
  gap: 6px;
  align-items: stretch;
  z-index: 9998;
  transform: translateX(-50%) translateY(-100%) translateY(-8px);
  pointer-events: auto;
`;

export const ToolbarRegion = styled.div`
  background-color: ${props => props.theme.colors.book.color2b};
  border-radius: ${props => props.theme.borderRadius.lg};
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: ${props => props.theme.shadows.lg};

  button {
    position: relative;
    display: flex;
    align-items: center;
    gap: ${props => props.theme.spacing.sm};
    background-color: transparent !important;
    color: ${props => props.theme.colors.white} !important;
    font-size: ${props => props.theme.fontSize.sm};
    font-weight: ${props => props.theme.fontWeight.medium};
    cursor: pointer;
    outline: none;
    padding: 0 0 0 12px;
    img {
      width: 14px;
      height: 14px;
    }
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 12px;
      background-color: ${props => props.theme.colors.border.ce};
    }
    &:first-child {
      padding-left: 0;  
      &::after {
        display: none;
      }
    }
  }

  html.dark-mode & {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.10);
    button {
      color: #0D0D0D !important;
    }
    button:hover {
      background-color: rgba(0, 0, 0, 0.06) !important;
    }
    img {
      filter: invert(1);
    }
  }
`;

export const ToolbarButton = styled.button<{ $variant?: 'highlight' | 'note' | 'remove' | 'copy' | 'chat' | 'underline' }>`
  position: relative;
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
  border: none;
  border-radius: ${props => props.theme.borderRadius.sm};
  background-color: ${props => {
    if (props.$variant === 'highlight') return '#FFEB3B';
    if (props.$variant === 'note') return '#E3F2FD';
    if (props.$variant === 'underline') return '#E8E4FF';
    if (props.$variant === 'remove') return props.theme.colors.error[100];
    if (props.$variant === 'copy') return props.theme.colors.gray[100];
    if (props.$variant === 'chat') return '#2b2b2b';
    return props.theme.colors.gray[100];
  }};
  color: ${props => {
    if (props.$variant === 'highlight' || props.$variant === 'note' || props.$variant === 'underline') return props.theme.colors.gray[900];
    if (props.$variant === 'remove') return props.theme.colors.error[700];
    if (props.$variant === 'chat') return props.theme.colors.white;
    return props.theme.colors.gray[700];
  }};
  font-size: ${props => props.theme.fontSize.sm};
  font-weight: ${props => props.theme.fontWeight.medium};
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.xs};

  &::before {
    content: '';
    position: absolute;
    top: -10px;
    left: -6px;
    right: -6px;
    bottom: -10px;
  }
/*
  &:hover {
    opacity: 0.8;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
*/
`;

export const DropdownMenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10001;
`;

export const DropdownMenuContainer = styled.div<{ $x: number; $y: number }>`
  position: fixed;
  left: ${props => props.$x}px;
  top: ${props => props.$y}px;
  transform: translateX(-50%);
  background-color: #2b2b2b;
  border-radius: ${props => props.theme.borderRadius.md};
  box-shadow: ${props => props.theme.shadows.xl};
  padding: ${props => props.theme.spacing.xs};
  z-index: 10002;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 2px;

  html.dark-mode & {
    background: #D4D4D4;
    border-radius: 8px;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.10);
  }
`;

export const DropdownMenuItem = styled.button`
  background-color: transparent;
  border: none;
  color: ${props => props.theme.colors.white};
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
  font-size: ${props => props.theme.fontSize.sm};
  font-weight: ${props => props.theme.fontWeight.medium};
  cursor: pointer;
  border-radius: ${props => props.theme.borderRadius.sm};
  transition: background-color 0.2s;
  text-align: left;
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
  
  &:hover {
    background-color: #3b3b3b;
  }

  html.dark-mode & {
    color: ${props => props.theme.colors.gray[900]};
    &:hover {
      background-color: rgba(0, 0, 0, 0.06);
    }
  }
  
  svg {
    width: 14px;
    height: 14px;
  }
`;

export const MoreButton = styled.button`
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
  border: none;
  border-radius: ${props => props.theme.borderRadius.sm};
  background-color: ${props => props.theme.colors.gray[200]};
  color: ${props => props.theme.colors.gray[700]};
  font-size: ${props => props.theme.fontSize.sm};
  font-weight: ${props => props.theme.fontWeight.medium};
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.xs};

  &:hover {
    opacity: 0.8;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
  
  svg {
    width: 14px;
    height: 14px;
  }
`;

export const CopyToast = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%) translateY(${props => props.$isVisible ? '0' : '20px'});
  background-color: #2b2b2b;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 10010;
  opacity: ${props => props.$isVisible ? 1 : 0};
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
`;
